export const usercontainerConstants = {
    USERCONTAINER_LIST_REQUEST: 'USERCONTAINER_LIST_REQUEST',
    USERCONTAINER_LIST_SUCCESS: 'USERCONTAINER_LIST_SUCCESS',
    USERCONTAINER_LIST_FAILURE: 'USERCONTAINER_LIST_FAILURE',

    USERCONTAINER_CREATE_REQUEST: 'USERCONTAINER_CREATE_REQUEST',
    USERCONTAINER_CREATE_SUCCESS: 'USERCONTAINER_CREATE_SUCCESS',
    USERCONTAINER_CREATE_FAILURE: 'USERCONTAINER_CREATE_FAILURE',
    // Distinct from FAILURE: the POST /container request was aborted (60s
    // client timer) or the network dropped, so the row may well have been
    // committed server-side. Never report this as a failure - re-fetch
    // /mycontainers to find out what actually happened.
    USERCONTAINER_CREATE_UNKNOWN: 'USERCONTAINER_CREATE_UNKNOWN',

    USERCONTAINER_DELETE_REQUEST: 'USERCONTAINER_DELETE_REQUEST',
    USERCONTAINER_DELETE_SUCCESS: 'USERCONTAINER_DELETE_SUCCESS',
    USERCONTAINER_DELETE_FAILURE: 'USERCONTAINER_DELETE_FAILURE',

    USERCONTAINER_ORDER_REQUEST: 'USERCONTAINER_ORDER_REQUEST',
    USERCONTAINER_ORDER_SUCCESS: 'USERCONTAINER_ORDER_SUCCESS',
    USERCONTAINER_ORDER_FAILURE: 'USERCONTAINER_ORDER_FAILURE',

    USERCONTAINER_CLEAR: 'USERCONTAINER_CLEAR',
};

// errorCode value for the aborted/network-failed create described above. Not
// an error code from the server - the server never answered.
export const USERCONTAINER_UNKNOWN_OUTCOME = 'unknown';

// The backend's accepted language strings, in the exact numeric order of
// state.languageswitch (a NUMBER 0-14, see reducers/languageswitch.reducer.js
// and the *_NR values in languageswitch.constants.js - verified index for
// index). Note Deutsch/Francais, NOT German/French: UserNewsContainerService
// falls back to DEFAULT_LANGUAGE = "English" silently for any value it does
// not recognise, so a wrong spelling here would show English news under a
// German card with no error anywhere.
export const CONTAINER_LANGUAGES = [
    'English',    // 0  ENGLISH_NR
    'Spanish',    // 1  SPANISH_NR
    'Deutsch',    // 2  DEUTSCH_NR
    'Francais',   // 3  FRANCAIS_NR
    'Portuguese', // 4  PORTUGUESE_NR
    'Hindi',      // 5  HINDI_NR
    'Indonesian', // 6  INDONESIAN_NR
    'Russian',    // 7  RUSSIAN_NR
    'Chinese',    // 8  CHINESE_NR
    'Japanese',   // 9  JAPANESE_NR
    'Arabic',     // 10 ARABIC_NR
    'Italian',    // 11 ITALIAN_NR
    'Turkish',    // 12 TURKISH_NR
    'Dutch',      // 13 DUTCH_NR
    'Greek'       // 14 GREEK_NR
];

// state.languageswitch number -> backend language string, defaulting to the
// backend's own default rather than sending undefined.
export function containerLanguage(languageswitch) {
    return CONTAINER_LANGUAGES[languageswitch] || CONTAINER_LANGUAGES[0];
}

// The 20 built-in PLATFORM container names, in server order and exact case
// (as returned by GET /mycontainers). Used for the client-side reserved-title
// pre-check before POST /container.
export const PLATFORM_NAMES = [
    'Twitter',
    'Facebook',
    'Instagram',
    'Telegram',
    'Reddit',
    'WhatsApp',
    'Snapchat',
    'TikTok',
    'Discord',
    'Tinder',
    'Twitch',
    'Linkedin',
    'Vkontakte',
    'Wechat',
    'YouTube',
    'Pinterest',
    'Github',
    'Signal',
    'Patreon',
    'Onlyfans'
];
